// @TODO: AK SA MENI KRAJINA, AJ TU TREBA ZMENIT
export const defaultCountry = "sk";
export const defaultCountryRegex = /^sk$/i;
export const vatNumberSlovakRegex = /^SK/i;

export function isValidForNotVatRegistration(country: string, vatNumber: string | null) {
  return (
    !defaultCountryRegex.test(country) &&
    !!vatNumber &&
    vatNumber.length > 2 &&
    !vatNumberSlovakRegex.test(vatNumber)
  );
}

export function addRegistrationFormHandler() {
  document.addEventListener("change", ({ target }) => {
    if (!(target instanceof HTMLElement)) return;
    if (!target.matches("#Form_NotVatRegistered")) return;

    const notVatRegisteredEl = document.getElementById("Form_NotVatRegistered") as HTMLInputElement;
    const notVatRegistered = notVatRegisteredEl?.checked ?? false;

    const options = document.querySelectorAll<HTMLOptionElement>(
      'select[autocomplete="country"] > option',
    );
    options.forEach((option) => {
      if (option.value !== defaultCountry) return;
      if (notVatRegistered) option.classList.add("hidden");
      else option.classList.remove("hidden");
    });
  });

  document.addEventListener("change", (event) => {
    const target = event.target as HTMLElement;
    if (!target.matches("#Form_BillingCountryCode") && !target.matches("#Form_VatNumber")) return;

    const countryEl = document.getElementById("Form_BillingCountryCode");
    const vatNumberEl = document.getElementById("Form_VatNumber");
    const notVatRegisteredEl = document.getElementById("Form_NotVatRegistered");

    if (
      !(countryEl instanceof HTMLSelectElement) ||
      !(vatNumberEl instanceof HTMLInputElement) ||
      !(notVatRegisteredEl instanceof HTMLInputElement)
    )
      return;

    if (isValidForNotVatRegistration(countryEl.value, vatNumberEl.value)) {
      notVatRegisteredEl.disabled = false;
      notVatRegisteredEl.parentElement?.setAttribute("aria-disabled", "false");
    } else {
      notVatRegisteredEl.checked = false;
      notVatRegisteredEl.disabled = true;
      notVatRegisteredEl.parentElement?.setAttribute("aria-disabled", "true");
    }
  });

  document.addEventListener("change", (event) => {
    const target = event.target as HTMLInputElement;
    if (!target.matches('[data-action="toggleAsOrganization"]')) return;

    const isOrganization = target.checked;

    const organizationFields = document.getElementById("organizationFields");
    organizationFields?.classList.toggle("hidden");

    const consentsFieldset = document.getElementById("consentsSection");
    const consentsEveryone = document.getElementById("consentsEveryone");

    const consentsCitizen = document.getElementById("consentsCitizen");
    consentsCitizen?.classList.toggle("hidden");

    const consentsCompany = document.getElementById("consentsCompany");
    consentsCompany?.classList.toggle("hidden");

    if (consentsEveryone) {
      consentsFieldset?.classList.remove("hidden");
    }

    if (isOrganization && !consentsCompany && !consentsEveryone) {
      consentsFieldset?.classList.add("hidden");
    } else if (isOrganization) {
      consentsFieldset?.classList.remove("hidden");
    }

    if (!isOrganization && !consentsCitizen && !consentsEveryone) {
      consentsFieldset?.classList.add("hidden");
    } else if (!isOrganization) {
      consentsFieldset?.classList.remove("hidden");
    }
  });
}

